module.exports = __webpack_public_path__ + "static/media/team-jonathan.ae2ce615.jpg";